import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { SayfalamaSonuc } from '@models/genel/SayfalamaSonuc';
import { IslemSonuc, IslemSonucLowercase } from '@models/genel/IslemSonuc';
import { FaturalarRaporOzetiInfo } from '@models/fatura/FaturalarRaporOzetiInfo';
import { FaturalarInfo } from '@core/models/fatura/FaturalarInfo';
import { SgkFaturaYukleInfo } from '@core/models/fatura/SgkFaturaYukleInfo';
import { FaturaRaporAramaKriterInfo } from '@core/models/fatura/FaturaRaporAramaKriterInfo';
import { ExcelAktarIslemSonuc } from '@core/models/genel/ExcelAktarIslemSonuc';
import { ExcelAktarFaturaInfo } from '@core/models/fatura/ExcelAktarFaturaInfo';
import { EpostaIleGonderInfo } from '@core/models/fatura/EpostaIleGonderInfo';
import { FaturaEtiketEkleGuncelleInfo } from '@core/models/fatura/FaturaEtiketEkleGuncelleInfo';
import { FaturaEtiketleriInfo } from '@core/models/fatura/FaturaEtiketleriInfo';
import { FaturaDosyaIndirmeSonuc } from '@core/models/genel/FaturaDosyaIndirmeSonuc';
import { OtominiParametrelerOutput } from '@core/models/fatura/OtominiParametrelerOutput';
import { AktifKullaniciBilgisiService } from '@core/auth/aktif-kullanici-bilgisi.service';
import { FaturaExcelDto } from '@core/models/fatura/FaturaExcelDto';
import { EDovizFaturalarInfo } from '@core/models/fatura/EDovizFaturalarInfo';
import { ExcelExportFilterDto } from '@core/models/fatura/ExcelExportFilterDto';
import { FaturaAramaKriterInfo } from '@core/models/fatura/FaturaAramaKriterInfo';
import { KdvRaporFilterDto } from '@core/models/fatura/KdvRaporFilterDto';
import { IptalDurumunaGetirDto } from '@core/models/fatura/IptalDurumunaGetirDto';
import { ItirazDurumunaGetirDto } from '@core/models/fatura/ItirazDurumunaGetirDto';
import { GondericiAliciPkInfo } from '@core/models/fatura/GondericiAliciPkInfo';

@Injectable()
export class FaturaService {

	constructor(private http: HttpClient) {

	}

	getData(aramaKriter?: any): Observable<SayfalamaSonuc> {
		return this.http.get<SayfalamaSonuc>(environment.API_FATURALAR_URL, { params: aramaKriter });
	}

	GetFaturaByAramaKriter(faturaAramaKriterInfo?: FaturaAramaKriterInfo): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.API_FATURALAR_URL + "GetFaturaByAramaKriter", faturaAramaKriterInfo);
	}

	getBABSRaporu(aramaKriter?: any): Observable<SayfalamaSonuc> {
		return this.http.get<SayfalamaSonuc>(environment.API_FATURALAR_URL + 'caribabsraporulistele', { params: aramaKriter });
	}

	// getKontorRaporu(aramaKriter?: any): Observable<SayfalamaSonuc> {
	// 	return this.http.get<SayfalamaSonuc>(environment.API_FATURALAR_URL + 'kontorraporulistele', { params: aramaKriter });
	// }

	// kontorRaporuExport(Kriter: FaturaRaporAramaKriterInfo): Observable<IslemSonuc> {
	// 	return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'kontorraporuexport/', Kriter);
	// }

	getRaporOzeti(aramaKriter?: any): Observable<FaturalarRaporOzetiInfo> {
		return this.http.get<FaturalarRaporOzetiInfo>(environment.API_FATURALAR_URL + 'faturalarraporozeti', { params: aramaKriter });
	}

	arsivDurumunuDegistir(arsivDurumInfo: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'arsivdurumunudegistir', arsivDurumInfo);
	}

	okunduBilgisiniDegistir(okunduInfo: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'okundubilgisinidegistir', okunduInfo);
	}

	gibeGonder(arsivDurumInfo: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'gibegonder', arsivDurumInfo);
	}

	faturaEkleGuncelle(faturaInfo: FaturalarInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL, faturaInfo);
	}
	topluFaturaCevapla(faturaCevaplamaInfo): Observable<IslemSonuc> {
    return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'toplufaturacevapla', faturaCevaplamaInfo);
}

	edovizFaturaEkleGuncelle(faturaInfo: EDovizFaturalarInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + "EDovizFaturaKaydet", faturaInfo);
	}

	xmlOlustur(faturaId: number): Observable<IslemSonuc> {
		return this.http.get<IslemSonuc>(environment.API_FATURALAR_URL + 'xmlolustur/' + faturaId);
	}

	// todo: bu metodun boşa çıkması gerek.
	// faturaSonlandirXmlKaydet(faturaIdler: any): Observable<IslemSonuc> {
	// 	return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'faturasonlandirxmlkaydet', faturaIdler);
	// }

	faturaKuyrugaEkle(faturaIdler: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'faturakuyrugaekle', faturaIdler);
	}

	hataliFaturaTekrarGonder(faturaId: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'hatalifaturatekrargonder', faturaId);
	}

	xmlIndir(faturaId: number): Observable<Blob> {
		return this.http.get(environment.API_FATURALAR_URL + 'xmlindir/' + faturaId, { responseType: "blob" });
	}

	xmlindirpublic(faturaId: number): Observable<Blob> {
		return this.http.get(environment.API_FATURALAR_URL + 'xmlindirpublic/' + faturaId, { responseType: "blob" });
	}

	gibXmlPdfIndirPublic(ettn: string, urlPath: string): Observable<Blob> {
		return this.http.get(environment.API_FATURALAR_URL + urlPath + ettn, { responseType: "blob" });
	}

	zarfXmlIndir(faturaId: number): Observable<Blob> {
		return this.http.get(environment.API_FATURALAR_URL + 'zarfXmlindir/' + faturaId, { responseType: "blob" });
	}

	pdfYazdir(faturaIdler: any): Observable<Blob> {
		return this.http.post(environment.API_FATURA_RAPOR_YAZDIR_URL + 'yazdir/', faturaIdler, { responseType: "blob" });
	}

	imzaliPdfYazdir(faturaIdler: any): Observable<Blob> {
		return this.http.post(environment.API_FATURA_RAPOR_YAZDIR_URL + 'imzaliYazdir/', faturaIdler, { responseType: "blob" });
	}

	pdfIndirPublic(faturaIdler: any): Observable<Blob> {
		return this.http.post(environment.API_FATURA_RAPOR_YAZDIR_URL + 'pdfIndirPublic/', faturaIdler, { responseType: "blob" });
	}

	ExceleAktar(aramaKriter: any): Observable<Blob> {
		return this.http.post(environment.API_FATURA_RAPOR_YAZDIR_URL + 'exceleaktar/', aramaKriter, { responseType: "blob" });
	}

	secililerXmlIndir(faturaIdler: any): Observable<Blob> {
		return this.http.post(environment.API_FATURALAR_URL + 'secililerxmlindir', faturaIdler, { responseType: "blob" });
	}

	secililerPdfGoster(faturaIdler: any): Observable<Blob> {
		return this.http.post(environment.API_FATURALAR_URL + 'secililerpdfgoster', faturaIdler, { responseType: "blob" });
	}

	secililerTekPdfIndir(faturaIdler: any): Observable<Blob> {
		return this.http.post(environment.API_FATURA_RAPOR_YAZDIR_URL + 'tekpdfac/', faturaIdler, { responseType: "blob" });
	}

	select(faturaId: number): Observable<FaturalarInfo> {
		return this.http.get<FaturalarInfo>(environment.API_FATURALAR_URL + 'GetFaturaDetayById'
			+ '?id= ' + faturaId
		);
	}

	selectEDovizFatura(faturaId: number): Observable<EDovizFaturalarInfo> {
		return this.http.get<EDovizFaturalarInfo>(environment.API_FATURALAR_URL + "getedovizfatura/" + faturaId.toString());
	}

	selectWithReferansNo(referansNo: string): Observable<FaturalarInfo> {
		return this.http.get<FaturalarInfo>(environment.API_FATURALAR_URL + referansNo);
	}

	exceleAktar(faturaIdlerInfo: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'exceleaktar', faturaIdlerInfo);
	}

	entegrasyonReferansNoIleFaturaGoruntuleme(faturaGoruntulemeInfo: any): Observable<FaturaDosyaIndirmeSonuc> {
		return this.http.post<FaturaDosyaIndirmeSonuc>(environment.API_FATURA_GORUNTULE + 'referansnoilefaturagoruntuleme', faturaGoruntulemeInfo);
	}

	faturaGoruntuleme(faturaGoruntulemeInfo: any): Observable<FaturaDosyaIndirmeSonuc> {
		return this.http.post<FaturaDosyaIndirmeSonuc>(environment.API_FATURA_GORUNTULE, faturaGoruntulemeInfo);
	}

	xsltfaturaGoruntuleme(faturaTipiId: number): Observable<FaturaDosyaIndirmeSonuc> {
		return this.http.get<FaturaDosyaIndirmeSonuc>(environment.API_FATURA_GORUNTULE + 'xsltonizle/' + faturaTipiId);
	}

	faturaYanitiGoruntuleme(faturaGoruntulemeInfo: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURA_GORUNTULE + 'faturayanitigoruntule', faturaGoruntulemeInfo);
	}

	publicFaturaGoruntuleme(faturaGoruntulemeInfo: any): Observable<FaturaDosyaIndirmeSonuc> {
		return this.http.post<FaturaDosyaIndirmeSonuc>(environment.API_FATURA_GORUNTULE + 'publicfaturagoruntule', faturaGoruntulemeInfo);
	}

	publicFaturaGoruntulemePDF(faturaGoruntulemeInfo: any): Observable<any> {
		return this.http.post(environment.API_FATURA_GORUNTULE + 'publicfaturagoruntulePDF', faturaGoruntulemeInfo, { responseType: "blob" });
	}

	faturaOnizle(faturaInfo: FaturalarInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURA_GORUNTULE + 'onizle', faturaInfo);
	}

	eDovizfaturaOnizle(faturaInfo: EDovizFaturalarInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURA_GORUNTULE + 'onizle', faturaInfo);
	}

	sil(id: number): Observable<any> {
		return this.http.delete<any>(environment.API_FATURALAR_URL + id.toString());
	}

	cokluFaturaSil(cokluFaturaSilInfo: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'coklufaturasil', cokluFaturaSilInfo);
	}

	// durumunuDegistir(faturaDurumInfo): Observable<IslemSonuc> {
	// 	return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'durumunudegistir', faturaDurumInfo);
	// }

	iptalEt(faturaIptalInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'iptalet', faturaIptalInfo);
	}

	faturaCevapla(faturaCevaplamaInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'faturacevapla', faturaCevaplamaInfo);
	}

	zarfSorgula(zarfId: string): Observable<any> {
		return this.http.get<any>(environment.API_FATURALAR_URL + 'zarfsorgulama/' + zarfId.toString());
	}

	sgkFaturaYukle(sgkFaturaYukleInfo: SgkFaturaYukleInfo): Observable<any> {
		return this.http.post<any>(environment.API_FATURALAR_URL + 'sgkfaturayukle', sgkFaturaYukleInfo.formData, { headers: { 'enctype': 'multipart/form-data', 'Content-Type': 'multipart/form-data' } });
	}

	faturaRaporYazdir(kriter: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURA_RAPOR_YAZDIR_URL, kriter);
	}

	faturalarExceleAktar(Kriter: FaturaRaporAramaKriterInfo): Observable<IslemSonuc> {
		//sultan
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'faturaexcelaktar/', Kriter);
	}
	cariBazliFaturaListesi(Kriter: FaturaRaporAramaKriterInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'caribazlifaturalistesipdf/', Kriter);
	}
	cariBaBsRaporuPdf(Kriter: FaturaRaporAramaKriterInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'caribabsraporupdf/', Kriter);
	}
	cariBaBsRaporuExcel(Kriter: FaturaRaporAramaKriterInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'caribabsraporuexcel/', Kriter);
	}
	excelTopluMalHizmetEkle(Kriter: ExcelAktarFaturaInfo): Observable<ExcelAktarIslemSonuc> {
		return this.http.post<ExcelAktarIslemSonuc>(environment.API_FATURALAR_URL + 'exceltoplumalhizmetekle/', Kriter);
	}

	ihracatExcelTopluMalHizmetEkle(Kriter: ExcelAktarFaturaInfo): Observable<ExcelAktarIslemSonuc> {
		return this.http.post<ExcelAktarIslemSonuc>(environment.API_FATURALAR_URL + 'ihracatexceltoplumalhizmetekle/', Kriter);
	}

	epostaileGonder(Kriter: EpostaIleGonderInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'epostailegonder/', Kriter);
	}

	buroGibAktivasyonDurumuSorgula(faturaTipiId: number): Observable<IslemSonuc> {
		return this.http.get<IslemSonuc>(environment.API_BUROLAR_URL + 'burogibaktivasyondurumusorgula/' + faturaTipiId);
	}

	faturaetiketleriGetData(faturaId: number): Observable<FaturaEtiketleriInfo[]> {
		return this.http.get<FaturaEtiketleriInfo[]>(environment.API_FATURALAR_URL + 'faturaetiketleri/' + faturaId);
	}
	faturaGbPketiketleriGetData(faturaId: number): Observable<GondericiAliciPkInfo[]> {
		return this.http.get<GondericiAliciPkInfo[]>(environment.API_FATURALAR_URL + 'faturagbpketiketleri/' + faturaId);
	}

	etiketEkleGuncelle(info: FaturaEtiketEkleGuncelleInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'etiketekle', info);
	}

	etiketKaldir(faturaId: number, etiketId: number): Observable<IslemSonuc> {
		return this.http.get<IslemSonuc>(environment.API_FATURALAR_URL + 'etiketkaldir/' + faturaId + "/" + etiketId);
	}

	getMuhasebeciMaliMusavirGorebilecekData(aramaKriter: FaturaAramaKriterInfo): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.API_FATURALAR_URL + 'muhasebecimalimusavirgorebileceklerigetir', aramaKriter);
	}

	tekrarMailGonder(faturaId: number): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'tekrarmailgonder', faturaId);
	}

	getMakbuztekHazirSatirlar(aramaKriter?: any): Observable<SayfalamaSonuc> {
		return this.http.get<SayfalamaSonuc>(environment.API_FATURALAR_URL + 'makbuztekhazirsatirlarigetir', { params: aramaKriter });
	}

	otominiGelenParametreleriMaple(parametreler: any) {
		return this.http.post<OtominiParametrelerOutput>(environment.API_FATURALAR_URL + 'otominiparametrelerimaple', parametreler);
	}

	getBugunFaturaInfo(): Observable<IslemSonuc> {
		return this.http.get<IslemSonuc>(environment.API_FATURALAR_URL + 'bugunfaturalarKontrol');
	}

	sgkFaturaYukleNew(formData: FormData): Observable<IslemSonucLowercase> {
		return this.http.post<IslemSonucLowercase>(environment.API_FATURALAR_URL + 'sgkfaturayukle', formData);
	}

	excelToEntegrasyonDto(excelDtoList: FaturaExcelDto[]): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'exceltoentegrasyondto', excelDtoList)
	}

	sgkFaturaKaydetveGibeGonder(faturaObj: FaturalarInfo): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'sgkfaturakaydetvegibegonder', faturaObj)
	}

	excelExport(excelExportFilterDto: ExcelExportFilterDto): Observable<any> {
		//sultan
		return this.http.post<any>(environment.API_FATURALAR_URL + 'excelexport/', excelExportFilterDto);
	}

	GetKdvRaporList(filterDto: KdvRaporFilterDto): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.API_FATURALAR_URL + 'getkdvraporlist', filterDto)
	}

	KdvRaporExcelIndir(filterDto: KdvRaporFilterDto): Observable<SayfalamaSonuc> {
		return this.http.post<SayfalamaSonuc>(environment.API_FATURALAR_URL + 'kdvraporexcelindir', filterDto)
	}

	IptalDurumunaGetir(dto: IptalDurumunaGetirDto): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'iptaldurumunagetir', dto)
	}

	ItirazDurumunaGetir(dto: ItirazDurumunaGetirDto): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(environment.API_FATURALAR_URL + 'itirazdurumunagetir', dto)
	}
	GetTaslakByIrsaliyeId(irsaliyeId: number): Observable<FaturalarInfo> {
		return this.http.get<FaturalarInfo>(environment.API_FATURALAR_URL + 'gettaslakbyirsaliyeid/' + irsaliyeId);
	}

	basariliFaturaXmlIndir(faturaId: number): Observable<Blob> {
		return this.http.get(environment.API_FATURALAR_URL + 'basariliFaturaXmlIndir/' + faturaId, { responseType: "blob" });
	}

	guidZarfDurumuSorgula(guid: string): Observable<any> {
		return this.http.get<any>(environment.API_FATURALAR_URL + 'guidZarfDurumuSorgula/' + guid);
	}

	faturaAlanlariniGuncelle(guid: string): Observable<any> {
		return this.http.get<any>(environment.API_FATURALAR_URL + 'faturaAlanlariniGuncelle/' + guid);
	}
}
